import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { OfferingCardLane } from '@ole-ui/ole-ui-components';
import useMobxStores from 'hooks/useMobxStores';
import { Link } from 'react-mobx-router5';
import { BaseOfferingCard } from 'components/OfferingCards';
import ExploreSubscriptions from 'components/ExploreSubscriptions';
import { CommonLaneProps } from './types';

const ContinueLearningLane = ({ expanded, onTitleClick }: CommonLaneProps) => {
  const { t } = useTranslation();
  const { progressStore, userStore } = useMobxStores();

  const visibleOfferings = progressStore.visibleOfferingsWithProgress;

  return (
    <OfferingCardLane
      className="new_lane"
      emptyMessage={
        <p className="empty-message">
          {t('There are no courses currently in progress.')}{' '}
          <Link href routeName="catalog">
            {t('Explore the Catalog')}
          </Link>
        </p>
      }
      expanded={expanded}
      items={visibleOfferings}
      leadingItem={
        userStore.isRHLSTrialSubscriber ? (
          <ExploreSubscriptions
            className="explore-subscriptions--my-training"
            isRHLSTrialCopy
          />
        ) : undefined
      }
      maxItems={25}
      onTitleClick={onTitleClick}
      renderItem={({ entry }) => <BaseOfferingCard entry={entry} />}
      title={t('Continue learning')}
    />
  );
};

export default observer(ContinueLearningLane);
